import { Pipe, PipeTransform } from '@angular/core';
import { getAiModels_ai_models } from 'src/gql-generated/generated';

@Pipe({ name: 'filterModelsByType' })
export class FilterModelsByTypePipe implements PipeTransform {
    /**
     * Filters a list of AI models by type
     * Returns a new list only consisting of items where item.type === type
     * @param items list of ai_models to filter
     * @param type type of models you want as result
     * @returns filtered list of models
     */
    transform(items: getAiModels_ai_models[], type: string): getAiModels_ai_models[] {
        return items.filter((item) => item.type === type);
    }
}
